import { format } from 'date-fns';

import { DATE_FORMAT, DATETIME_FORMAT } from '@/constants';
import type { ValueFormatterParams } from '@/grid/types';
import { parseUtcInstant } from '@/utils/wallClock';

type Params = { value: string } | ValueFormatterParams<any, string>;

// System timestamps (createdOn/modifiedOn) are real UTC, unlike other API dates;
// see parseUtcInstant in src/utils/wallClock.ts
function formatUtcInstant(params: Params, pattern: string): string {
  const date = parseUtcInstant(params.value);
  return date ? format(date, pattern) : '';
}

export function utcDateTimeFormatter(params: Params): string {
  return formatUtcInstant(params, DATETIME_FORMAT);
}

export function utcDateFormatter(params: Params): string {
  return formatUtcInstant(params, DATE_FORMAT);
}
